export default { sha: 'ba643558096edde686e9b041a53243f588ec64dc', buildNumber: 'undefined' }
